import { parse } from '@babel/parser'

export function validateSource (value) {
  const source = value || ''
  if (!source.trim()) {
    return []
  }

  try {
    parse(source, {
      sourceType: 'script',
      allowAwaitOutsideFunction: true,
      allowReturnOutsideFunction: true,
      plugins: []
    })
    return []
  } catch (error) {
    return [{
      row: (error?.loc?.line || 1) - 1,
      column: error?.loc?.column || 0,
      text: (error?.message || 'Syntax error').replace(/\s*\(\d+:\d+\)\s*$/, ''),
      type: 'error'
    }]
  }
}
